/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SIM_EMPTY_DEFAULT_OPTIONS as ɵb,SimEmptyDefaultOptions as ɵa} from './default-options';